module.exports = __webpack_public_path__ + "img/refused.cd34bf72.svg";